import React from 'react';
import PageSeo from '../components/seo/PageSeo';
import { Link, useSearchParams } from 'react-router-dom';
import NewsImage from '../components/NewsImage';
import NewsRowList from '../components/NewsRowList';
import Pagination from '../components/Pagination';
import Subsections from '../subsections/Subsections';
import NewsListSkeleton from '../components/NewsListSkeleton';
import { useCategoryNewsQuery } from '../hooks/useNewsListQuery';
import '../styles/SubsectionContent.css';
import '../App.css';

const Tournaments = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const newsPerPage = 25;
  const currentPage = Number(searchParams.get('page')) || 1;
  const neededLimit = currentPage * newsPerPage;
  const {
    news: tournamentNews,
    initialLoading,
    isRefreshing,
    totalCount,
  } = useCategoryNewsQuery('Турніри', neededLimit);
  const totalPages = Math.max(1, Math.ceil(totalCount / newsPerPage));

  const handlePageChange = (page) => {
    setSearchParams({ page: String(page) });

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const startIndex = (currentPage - 1) * newsPerPage;
  const pageNews = tournamentNews.slice(startIndex, startIndex + newsPerPage);

  const heroNews = pageNews[0];
  const restNews = pageNews.slice(1);

  return (
    <div className="home-container panel panel--spaced" aria-busy={isRefreshing}>
      <PageSeo routePath="/tournaments" />
      <h1>ТУРНІРИ</h1>

      <Subsections category="Турніри" />

      <div className="news-content-wrapper">
        {initialLoading && tournamentNews.length === 0 ? (
          <NewsListSkeleton count={8} />
        ) : (
          <>
          <div className="subsection-news-layout">
            {heroNews && (
              <Link
                to={`/news/${heroNews.id}`}
                className="subsection-hero-news"
              >
                <NewsImage news={heroNews} alt={heroNews.title} loading="eager" />

                <div className="subsection-hero-overlay">
                  <span>
                    {heroNews.day}.{heroNews.month}.{heroNews.year}
                    {heroNews.time ? ` ${heroNews.time}` : ''}
                  </span>

                  <h2>{heroNews.title}</h2>
                </div>
              </Link>
            )}

            <NewsRowList news={restNews} />
          </div>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              disabled={isRefreshing}
              sequential
              pageType="category"
              category="Турніри"
            />
          )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tournaments;
